/* ══════════════════════════════════════════════════════════════════════════
 * classLogoApi — submit a student class logo / design from the create-school
 * form to the Laravel backend (multipart, so the artwork files ride along).
 * ══════════════════════════════════════════════════════════════════════════ */

import { CMS_API_URL } from '../../../../config/apiBase';

/**
 * @param {string} brandSlug  Backend brand slug (e.g. 'clsdk').
 * @param {object} data       { schoolId, shopId, className, classFromList,
 *                              color, ink, brystlogo, trykfarver[], placeringer[],
 *                              klasseRep{}, frontFile?, backFile? }
 */
export async function submitClassLogo(brandSlug, data) {
  const fd = new FormData();
  fd.append('schoolId', String(data.schoolId ?? ''));
  if (data.shopId != null && data.shopId !== '') fd.append('shopId', String(data.shopId));
  fd.append('className', data.className ?? '');
  fd.append('classFromList', data.classFromList ? '1' : '0');
  if (data.color) fd.append('color', data.color);
  if (data.ink) fd.append('ink', data.ink);
  if (data.brystlogo) fd.append('brystlogo', data.brystlogo);

  (data.trykfarver ?? []).forEach((v) => fd.append('trykfarver[]', v));
  (data.placeringer ?? []).forEach((v) => fd.append('placeringer[]', v));

  Object.entries(data.klasseRep ?? {}).forEach(([k, v]) => {
    if (v != null && v !== '') fd.append(`klasseRep[${k}]`, typeof v === 'string' ? v : String(v));
  });

  // Free-form extras (e.g. backPrintSize) — stored verbatim on the submission.
  Object.entries(data.extra ?? {}).forEach(([k, v]) => {
    if (v != null && v !== '') fd.append(`extra[${k}]`, String(v));
  });

  if (data.frontFile) fd.append('frontFile', data.frontFile);
  if (data.backFile) fd.append('backFile', data.backFile);

  const res = await fetch(`${CMS_API_URL}/api/schools/${brandSlug}/class-logo`, {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: fd,
  });

  let payload = null;
  try { payload = await res.json(); } catch { payload = null; }

  if (!res.ok) {
    const message = (payload && (payload.error || payload.message)) || 'Something went wrong. Please try again.';
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }
  return payload;
}
